module.exports = __webpack_public_path__ + "img/bg.a993f0d3.png";